import * as React from 'react';

export function FaqIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="8" fill="#0468FF" fillOpacity=".1" />
      <path fill="#0468FF" fillRule="evenodd" d="M8 6a1 1 0 100-2 1 1 0 000 2zm1 6V7H7v5h2z" clipRule="evenodd" />
    </svg>
  );
}
